export default "__VITE_ASSET__dydu17yL__"